import { render, staticRenderFns } from "./info_enfermedades.vue?vue&type=template&id=142c9c34"
import script from "./info_enfermedades.vue?vue&type=script&lang=js"
export * from "./info_enfermedades.vue?vue&type=script&lang=js"
import style0 from "./info_enfermedades.vue?vue&type=style&index=0&id=142c9c34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports